export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            per_page: 10,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        rowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectRow'
            }
        ],
    }
}
